import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiLogoGeneratorConfig } from '@/data/landingConfig/landingAiLogoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiLogoGenerator } from './schemaObject';

interface Props {}
const AiLogoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiLogoGenerator} />
			<LandingTemplate
				data={landingAiLogoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiLogoGenerator()}
			/>
		</>
	);
};

export default AiLogoGenerator;
